export default __webpack_public_path__ + "static/media/rhenus-x.cd45b2a8.svg";